<template>
  <div class="vx-card" style="height: 80vh; overflow-y: scroll;">
    <div class="mt-10">
      <div style="text-align: center;font-size: xx-large;">
        İZİN TALEP FORMU
      </div>
    </div>

    <div>
      <div style="margin-left:43px;margin-top:25px">
        <label style="color:dark-blue;margin-right:20px">Talep Eden</label> <b> {{ permission[0].userName }}</b>
      </div>
    </div>

    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Sebebi
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <v-select
          name="permissionTypeSelection"
          v-model="permission[0].permissionTypeId"
          placeholder="İzin Tür"
          :options="permissionTypeList"
          label="permissionTypeName"
          class="w-full"
          :reduce="(row) => row.permissionTypeId"
          @input="$event != undefined ? (permission[0].permissionTypeName = permissionTypeList.find((r) => r.permissionTypeId == $event).permissionTypeName) : undefined"
        >
          <span slot="no-options">Eşleşen Veri Yok</span>
        </v-select>
      </div>
    </div>
    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İrtibat Numaraları
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <vs-textarea v-model="permission[0].contactNumber" />
      </div>
    </div>
    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        Gidilecek Adres
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <vs-textarea v-model="permission[0].contactAddress" />
      </div>
    </div>

    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Başlangıç Tarih
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <input class="w-full" type="date" v-model="permission[0].startDate" />
      </div>
    </div>
    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Bitiş Tarih
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <input class="w-full" type="date" v-model="permission[0].finishDate" />
      </div>
    </div>
    <!-- 
    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Başlangıç Tarih
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <datepicker v-model="permission[0].startDate" ></datepicker>
      </div>
    </div>
    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Bitiş Tarih
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <datepicker v-model="permission[0].finishDate"  ></datepicker>
      </div>
    </div> -->

    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        İzin Gün Sayı
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">{{ Math.floor((new Date(permission[0].finishDate) - new Date(permission[0].startDate)) / 1000 / 60 / 60 / 24) }} Gün</div>
    </div>

    <div class="vx-row flex mt-10">
      <div class="vx-col flex items-center" style="width: 20%;margin-left: 49px">
        Açıklama
      </div>
      <div style="width: 60%;" class="vx-col flex items-center">
        <vs-textarea v-model="permission[0].description" />
      </div>
    </div>

    <div v-if="permission[0].status == 'T' && (permission[0].userId == $store.state.userData.userId || permission[0].operation == 'InsertPermission')" style="width: 100%;text-align: -webkit-center">
      <vs-button style="width: 50%;" @click="savePermissionForm()">Kaydet ve Onaya Gönder</vs-button>
    </div>
  </div>
</template>

<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      maxPageNumbers: 8,
      permissionId: undefined,
      searchName: undefined,
      permissionTypeList: [],
      permission: [
        {
          permissionId: null,
          status: "T",
          permissionTypeId: null,
          permissionTypeName: null,
          contactNumber: null,
          description: null,
          startDate: undefined,
          finishDate: undefined,
          contactAddress: null,
          firstApproveDate: null,
          secondApproveDate: null,
          userId: null,
          operation: null,
          userName: this.$store.state.userData.userName,
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload();
      }
    },
  },
  created: async function() {
    Promise.all([this.getPermissionType()]);
    //Güncelleme için URL den permissionId çekiliyor
    console.log("this.$route.name:",this.$route.name);
    if (this.$route.params != null && this.$route.name == "PermissionEdit" && this.$route.params.permissionId > 0) {
      this.permissionId = this.$route.params.permissionId;
      await this.getPermissionById();
      this.permission[0].operation = "UpdatePermission";
    } else if (this.$route.params != null && this.$route.name == "permissionview" && this.$route.params.permissionId > 0) {
      this.permissionId = this.$route.params.permissionId;
      this.getPermissionById();
      this.permission[0].operation = "ViewPermission";
    } else {
      this.permission[0].operation = "InsertPermission";
    }
  },

  methods: {
    getPermissionById: async function() {
      let result = await repository.getById("HumanResource/getPermissionById" + "/" + this.permissionId, this.permissionId);
      this.permission = result.list;
      this.permission[0].startDate = this.permission[0].startDate.substr(0, 10);
      this.permission[0].finishDate = this.permission[0].finishDate.substr(0, 10);
    },

    getPermissionType: async function() {
      this.permissionTypeList = await repository.getAll("HumanResource/getPermissionType").then((r) => r.list);
    },

    savePermissionForm: async function() {
      this.$vs.loading();
      let result = await repository.postEntity("HumanResource/savePermission", this.permission[0]);

      this.$vs.loading.close();

      if (result.isSuccessful) {
        await this.$swal.fire(`${result.returnID} Nolu Talep Başarıyla kaydedildi ve onaya gönderildi.`);
        this.$router.push("../management/");
      }
    },

    clearAllSelectedProducts() {
      this.gridOptions.api.deselectAll();
      this.selectedRows = [];
    },

    //aktif olan sayfada gördüklerimizi seçmek için
    selectDisplayedProducts() {
      let urunler = this.gridApi.getRenderedNodes();
      for (let a = 0; a < urunler.length; a++) this.gridApi.getRowNode(urunler[a].id).setSelected(true);
    },

    //Filtrelenen ürünlerin seçilmesi için
    selectFilteredProducts() {
      let filtered = this.gridApi.rowModel.rowsToDisplay;
      for (let i = 0; i < filtered.length; i++) {
        this.gridApi.getRowNode(filtered[i].id).setSelected(true);
      }
    },

    beforeChangeForTab2: async function() {
      let validationResult = true;

      this.selectedRows.forEach((row) => {
        if (!row.purchaseAmount) {
          this.$vs.notify({
            title: "Hata",
            text: "Miktar Giriniz",
            color: "danger",
          });
          validationResult = false;
          return false;
        } else if (!row.purchaseAmountTypeId) {
          this.$vs.notify({
            title: "Hata",
            text: "Miktar Tür Giriniz",
            color: "danger",
          });
          validationResult = false;
          return false;
        } else if (!row.purchaseSupplierId) {
          this.$vs.notify({
            title: "Hata",
            text: "Tedarikçi Firma",
            color: "danger",
          });
          validationResult = false;
          return false;
        }
      });

      return validationResult;
    },
  },
};
</script>
